import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/wx/auth/login',
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}

// 获取验证码
export function captchaIsEnable() {
  return request({
    url: '/captchaIsEnable',
    method: 'get'
  })
}

//微信扫码登录web端，轮训校验验证码
export function validUserByCode(code) {
  return request({
    url: '/wx/auth/valid-code',
    method: 'get',
    params: { code }
  })
}

//确认选择的企业
export function sureEnterprise(data) {
  return request({
    url: '/wx/auth/sureEnterprise',
    method: 'post',
    data,
  });
}


// WEBPACK FOOTER //
// ./src/api/login.js